import CookiesService from 'ember-cookies/services/cookies';

export default CookiesService;
